// (c) chaehongee. Confidential and proprietary.

import { buildApiUrl, http } from './http'

export interface AiModelListItem {
    id: string
    headshot_url?: string | null
}

export interface AiModelListResponse {
    page: number
    page_size: number
    total: number
    items: AiModelListItem[]
}

export interface ListAiModelsParams {
    page?: number
    page_size?: number
}

// Simple in-memory cache keyed by "page:page_size"
type CacheKey = string
interface CacheEntry {
    value: AiModelListResponse
    expiresAt: number
}
const CACHE_TTL_MS = 60 * 60_000 // 60 minutes
const aiModelsCache = new Map<CacheKey, CacheEntry>()
function makeKey(params?: ListAiModelsParams): CacheKey {
    const p = params?.page ?? 1
    const s = params?.page_size ?? 30
    return `${p}:${s}`
}

export async function listAiModels(params?: ListAiModelsParams): Promise<AiModelListResponse> {
    const url = new URL(buildApiUrl('/ai-models/'))
    if (params?.page) url.searchParams.set('page', String(params.page))
    if (params?.page_size) url.searchParams.set('page_size', String(params.page_size))
    return await http<AiModelListResponse>(url.toString(), { method: 'GET' })
}

export async function listAiModelsCached(params?: ListAiModelsParams): Promise<AiModelListResponse> {
    const key = makeKey(params)
    const now = Date.now()
    const cached = aiModelsCache.get(key)
    if (cached && cached.expiresAt > now) {
        return cached.value
    }
    const value = await listAiModels(params)
    aiModelsCache.set(key, { value, expiresAt: now + CACHE_TTL_MS })
    return value
}

export function invalidateAiModelsCache(): void {
    aiModelsCache.clear()
}


